import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../data/services";
import Reveal from "../components/Reveal";

export default function Services() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main data-testid="services-page" className="pt-32 md:pt-40 bg-[#f4f3ee]">
      <section className="relative z-10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <span className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#2f4bff]">
              / Work items
            </span>
            <h1 className="mt-6 font-head text-5xl sm:text-6xl md:text-8xl font-extrabold tracking-tight leading-[0.92] max-w-4xl text-[#111111]">
              What I can do for you.
            </h1>
            <p className="mt-8 font-body text-lg md:text-xl text-neutral-600 max-w-2xl leading-relaxed">
              A full menu of engineering services — from modernizing decades-old
              systems to shipping brand-new cloud-native applications. Every
              engagement is led personally by Shawn Rye.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="relative z-10 py-20 md:py-28">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="flex flex-col">
            {SERVICES.map((service, i) => {
              const Icon = service.icon;
              return (
                <Reveal key={service.id} delay={i * 0.04}>
                  <div
                    data-testid={`service-row-${service.id}`}
                    className="group grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 py-12 border-t border-black/10 hover:border-[#2f4bff] transition-colors"
                  >
                    <div className="md:col-span-1">
                      <span className="font-mono-tech text-xl text-neutral-400 group-hover:text-[#2f4bff] transition-colors">
                        {service.index}
                      </span>
                    </div>
                    <div className="md:col-span-4">
                      <Icon className="h-8 w-8 text-[#2f4bff] mb-5" />
                      <h2 className="font-head text-3xl md:text-4xl font-semibold tracking-tight leading-tight text-[#111111]">
                        {service.title}
                      </h2>
                      <p className="mt-3 font-mono-tech text-xs uppercase tracking-[0.15em] text-neutral-500">
                        {service.tagline}
                      </p>
                    </div>
                    <div className="md:col-span-4">
                      <p className="font-body text-lg text-neutral-600 leading-relaxed">
                        {service.summary}
                      </p>
                    </div>
                    <div className="md:col-span-3">
                      <ul className="space-y-3">
                        {service.points.map((p) => (
                          <li
                            key={p}
                            className="flex items-start gap-3 font-body text-neutral-700"
                          >
                            <Check className="h-4 w-4 text-[#2f4bff] mt-1 shrink-0" />
                            <span>{p}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                </Reveal>
              );
            })}
          </div>
        </div>
      </section>

      <section className="relative z-10 py-20 md:py-28 border-t border-black/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <div className="bg-white border border-black/10 p-10 md:p-16 flex flex-col md:flex-row md:items-center justify-between gap-8">
              <div>
                <h2 className="font-head text-3xl md:text-5xl font-bold tracking-tight max-w-2xl leading-[1.05] text-[#111111]">
                  Not sure where to start? Let&apos;s scope it together.
                </h2>
                <p className="mt-4 font-body text-neutral-600 max-w-xl">
                  Send over the details and I&apos;ll recommend the right path
                  forward.
                </p>
              </div>
              <Link
                to="/contact"
                data-testid="services-cta-contact"
                className="group inline-flex items-center gap-3 bg-[#2f4bff] text-white font-mono-tech text-sm uppercase tracking-[0.12em] px-8 py-5 hover:bg-[#111111] transition-colors duration-300 whitespace-nowrap"
              >
                Get in touch
                <ArrowUpRight className="h-5 w-5 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
              </Link>
            </div>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
